import {affirmAvailableForTotal} from "../../lib/affirmHelpers";
import {applePayAvailable} from "./applePayHelpers";
import {camelizeKeys} from "../../ReduxStore/Helpers/transformObject";
import {trim,uniq} from "lodash";

function paymentTypesToList(list) {
  if (Array.isArray(list)) {
    return [...list];
  }

  return `${list}`.split(/ /).map(x => trim(x));
}

/**
 * Used by both Cart and Checkout, this will get the list of payment
 * types, like ['credit_card', 'paypal']
 * @param props
 * @returns {*}
 */
export function getEnabledPaymentTypes({shoppingCart={}, currentAgent, cartConfig={}}) {
  if (_.isEmpty(cartConfig)) {
    cartConfig = getCheckoutConfig({shoppingCart});
  }

  cartConfig = camelizeKeys(cartConfig);

  // cart/checkout put effectiveTotal in different places because I was stupid.
  const effectiveTotal = shoppingCart?.effectiveTotal || shoppingCart?.totals?.effectiveTotal;

  if (! effectiveTotal) {
    console.warn("getEnabledPaymentTypes: cannot determine total in cart/checkout")
  }

  let list = paymentTypesToList(cartConfig.paymentTypes || ['credit_card']);

  if (currentAgent && currentAgent.username) {
    let agentTypes =  paymentTypesToList(cartConfig.agentPaymentTypes || ['agent_none']);

    for (let t of agentTypes)
      list.push(t);
  }

  if (!affirmAvailableForTotal(effectiveTotal, cartConfig)) {
    list = list.filter(item => item != 'affirm');
  }

  if (!applePayAvailable()) {
    list = list.filter(item => item != 'apple');
  }

  return uniq(list);
}

export function getCheckoutConfig({cartConfig, ...props}) {
  if (!_.isEmpty(cartConfig))
    return cartConfig;

  // look for it inside checkout/cart object
  for (let k of ['checkout', 'cart', 'shoppingCart']) {
    let obj = props[k];

    if (obj && !_.isEmpty(obj.cartConfig)) {
      return obj.cartConfig;
    }
  }

  return {};
}
